import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';

@Component
export class SearchOverlay extends ThemeComponent {
    private close: string = '';
    private _onCloseChange = new SimpleEvent<string>();

    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    init() {
        this.$listen(this, 'click', () => {
            this._onCloseChange.dispatch(this.close);
            this.closeOverlay();
        });
    }

    public openOverlay() {
        this.classList.add('visible');
    }

    public closeOverlay() {
        this.classList.remove('visible');
    }

    public toggleOverlay() {
        if (this.classList.contains('visible')) {
            this.closeOverlay();
        } else {
            this.openOverlay();
        }
    }
}
